import { render, staticRenderFns } from "./ModalAddNewTarifSematha.vue?vue&type=template&id=1fb63f0d&scoped=true&"
import script from "./ModalAddNewTarifSematha.vue?vue&type=script&lang=js&"
export * from "./ModalAddNewTarifSematha.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddNewTarifSematha.vue?vue&type=style&index=0&id=1fb63f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb63f0d",
  null
  
)

export default component.exports